var $ = require("jquery")
window.$ = window.jQuery = $
jQuery = $
import bootstrap from 'bootstrap/js/dist/modal.js'
var accrue = require('accrue')


$(function() {
	var $hamburger = $(".hamburger");
	$hamburger.on("click", function(e) {
	$hamburger.toggleClass("is-active");
	$('.head__mobilemenu').addClass('mmenu');
	$(".head__mobilemenu").toggle();
	});

	$(".head__mobileItems > li > a").on("click", (function(e) {
			$(".head__mobileItems ul").hide(),
			$(this).siblings("ul").length > 0 && !$(this).siblings("ul").is(":visible") && (e.preventDefault(),
			$(this).siblings("ul").show())
		}
	));

	$(".site__accordionInner").first().addClass("show");
	$(".site__accordionInner").first().css("display", "block");

	$('.toggle').click(function(e) {
	  	e.preventDefault();

	    var $this = $(this);

	    if ($this.next().hasClass('show')) {
	        $this.next().removeClass('show');
	        $this.next().slideUp(350);
	    } else {
	        $this.parent().parent().find('.site__accordionInner').removeClass('show');
	        $this.parent().parent().find('.site__accordionInner').slideUp(350);
	        $this.next().toggleClass('show');
	        $this.next().slideToggle(350);
	    }
	});

	var zipCodeArray = ["77471", "77469", "77833", "77406", "77494", "77450", "77459", "77498", "77479", "77084", "77489", "77802", "77801", "77094", "77492", "77842", "77079", "77805", "77043", "77496", "77487", "77491", "77481", "77497", "77806", "77413", "77843", "77844", "77477", "77545", "77803", "77840", "77083", "77808", "77478", "77807", "77053", "77834", "77082", "77077"];
	$(function() {
		$(".membershipZip").keyup(function(){
		   var zip = $(this).val();
			if(zip.length >4){
			 if($.inArray(zip, zipCodeArray) > -1){
			   $(location).attr('href', '/account-application/')
			 }else{
				$('#speedbump').modal('show')
				$('h4.modal-title').replaceWith( '<h4 class="modal-title">Membership Eligibility</h4>' );
				$('.modal-body p').replaceWith( '<p>We cannot locate your zip code in our database. Please call 281-391-2149 to verify that your zip code is within our field of membership</p>' );
				$('.modal-footer').remove();
			 }
		   }
		});
	});

	$(".calculator-loan").accrue({
		mode: "basic",
		operation: "button",
		default_values: {
		    amount: "",
		    rate: "",
		    rate_compare: "",
		    term: "",
		  },
		field_titles: {
		    amount: "LOAN AMOUNT",
			term: "LOAN LENGTH IN MONTHS",
		    rate: "INTEREST RATE",
		  },
		response_basic:
	    '<span>%payment_amount%</span>'
	});

	$('.resetBtn').click(function() {
	    $('.calculator-loan input[type="text"]').val('');
		$('.results span').remove();
	  });

	$(window).on('load', function(){
		$.expr[":"].external = function(a) {
			var linkhn = $(a)[0].hostname.split('.').reverse();
			var linkHref = linkhn[1] + "." + linkhn[0];
			var domainhn = window.location.hostname.split('.').reverse();
			var domainHref = domainhn[1] + "." + domainhn[0];
			return !a.href.match(/^mailto\:/) && !a.href.match(/^tel\:/) && !a.href.match(/^javascript\:/) && !a.classList.contains('disable') && linkHref !== domainHref;
		};
		$("a:external").addClass("ext_link");
		$(function() {
			$('a.ext_link').click(function() {
				 // open a modal
				$('a:external').attr('data-toggle', 'modal');
				$('a:external').attr('data-target', '#speedbump');
				//go to link on modal close
				var url = $(this).attr('href');
				var title = $(this).attr('title');
				if (title) {
					$('h4.modal-title').replaceWith( '<h4 class="modal-title">' + title + '</h4>' );
				}else {
					$('h4.modal-title').replaceWith( '<h4 class="modal-title">NOTICE</h4>' );
				}

				$('.btn-modal.btn-continue').click(function() {
					window.open(url);
					$('.btn-modal.btn-continue').off();
				});
				$('.btn-modal.btn-close').click(function() {
					$('#speedbump').modal('hide');
					$('.btn-modal.btn-close').off();
				});
			});

		});
	});

})
